import { createStore } from 'vuex';

import userStorage from './plugins/userStorage';

import globals from './modules/globals';
import authorization from './modules/authorization';

const store = createStore({
  plugins: [userStorage.plugin],
  modules: {
    globals,
    authorization,
  },
});

export default store;
